import { ArbCreateDto } from './dto/arb-create.dto';
import { ApiService } from '../../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { ArbCommandResultDto } from './dto/arb-command-result.dto';
import { ArbCreateResultDto } from './dto/arb-create-result.dto';
import { ArbReadDto } from './dto/arb-read.dto';

@Injectable({
  providedIn: 'root',
})
export class ArbService {
  constructor(private _apiService: ApiService) {}

  public createArb(arb: ArbCreateDto): Promise<ArbCreateResultDto> {
    return this._apiService.post('Arbs', arb);
  }

  public getArbByBillingId(billingId: number): Promise<ArbReadDto> {
    return this._apiService.get(`Arbs/billing/${billingId}`);
  }

  public cancelArbByBillingId(billingId: number): Promise<ArbCommandResultDto> {
    return this._apiService.delete(`Arb/${billingId}`);
  }

  public importArbTransactionsByDateRange(startDate: Date, endDate: Date): Promise<any> {
    return this._apiService.post(`Arb/ImportByDateRange?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`, null);
  }
}
